import fetch from '@/common/js/http';

const workHours = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {

    // 工时审批查询当日
    getWorkHoursInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: 'user/approve',
          method: 'get',
          params: params
        }).then(success => {
          resolve(success)
        }, error => {
          reject(error)
        })
      })
    },


    // 工时审批查询全部
    getWorkHoursAll({ commit }, params) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: 'user/approve/all',
          method: 'get',
          params: params
        }).then(success => {
          resolve(success)
        }, error => {
          reject(error)
        })
      })
    },


    // 工时审批提交
    commitWorkHours({ commit }, params) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "user/approve",
          method: 'put',
          data: params
        }).then(success => {
          resolve(success)
        }, error => {
          reject(error)
        })
      })
    },

  }
}
export default workHours



// WEBPACK FOOTER //
// ./src/vuex/modules/workHours.js